import {
  DefaultFooter,
  TotalSoldFooter,
  CustomerActivityFooter,
  XpressShippingFooter,
  TrendingDealFooter,
} from './components';

const Footer = () => null;

Footer.Default = DefaultFooter;
Footer.Box = TotalSoldFooter;
Footer.CustomerActivity = CustomerActivityFooter;
Footer.XpressShipping = XpressShippingFooter;
Footer.TrendingDeal = TrendingDealFooter;

export default Footer;
